import { useSeo } from "@/lib/seo";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-xl font-semibold text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-300">{children}</div>
  </div>
);

export default function Terms() {
  useSeo({
    title: "Terms of Use",
    description:
      "Terms of Use for the HILDRETH TECHNOLOGIES LLC company website, covering informational purpose, content ownership, third-party links, and governing law.",
    path: "/terms-of-use",
  });

  return (
    <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
      <p className="text-sm font-semibold uppercase tracking-wider text-sky-400">Legal</p>
      <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight text-white">
        Terms of Use
      </h1>
      <p className="mt-4 text-sm text-slate-500">Effective date: July 2026</p>
      <p className="mt-6 text-sm leading-relaxed text-slate-300">
        These Terms of Use govern your access to and use of the company website
        of HILDRETH TECHNOLOGIES LLC. By using this website, you agree to these
        terms.
      </p>

      <Section title="Informational and marketing purpose">
        <p>
          This website is provided for general informational and marketing
          purposes about HILDRETH TECHNOLOGIES LLC and its products. It does not
          constitute professional, medical, legal, or financial advice.
        </p>
      </Section>

      <Section title="Ownership of website content">
        <p>
          The content on this website, including text, layout, graphics, and the
          Hildreth Technologies name and “HT” monogram, is owned by or licensed to
          HILDRETH TECHNOLOGIES LLC and is protected by applicable law. You may not
          reproduce or redistribute website content without permission, except as
          reasonably necessary for normal viewing.
        </p>
      </Section>

      <Section title="Third-party and project links">
        <p>
          This website links to separate product websites and third-party
          resources. We are not responsible for the content, availability, or
          policies of external websites. Product websites are governed by their
          own terms and privacy policies.
        </p>
      </Section>

      <Section title="No warranty regarding availability">
        <p>
          This website is provided on an “as is” and “as available” basis. We do
          not warrant that the website will be uninterrupted, error-free, or
          continuously available, and we may modify or discontinue any part of it
          at any time.
        </p>
      </Section>

      <Section title="Appropriate use of the site">
        <p>
          You agree to use this website lawfully and not to interfere with its
          operation, attempt to gain unauthorized access, submit malicious or
          misleading information, or misuse the contact form.
        </p>
      </Section>

      <Section title="Contact information">
        <p>
          Questions about these Terms of Use may be directed to{" "}
          <a href="mailto:support@hildrethtechnology.com" className="font-medium text-sky-300 hover:text-sky-200">
            support@hildrethtechnology.com
          </a>
          .
        </p>
      </Section>

      <Section title="Governing law">
        <p>
          These Terms of Use are governed by the laws of the State of Florida,
          without regard to its conflict-of-law principles.
        </p>
      </Section>
    </div>
  );
}
